export default "__VITE_PUBLIC_ASSET__ce8b372a__"